export default function ({ redirect, $auth }) {
  if (!$auth.user.is_system_admin) {
    redirect({
      path: "/arm",
    })
  }
}
